import { Tenant, TenantRequest } from './entities';
import { fetch } from '@maxtropy/components';
import qs from 'qs';

export function getRoot(params: TenantRequest): Promise<Tenant[]> {
  return fetch(`/api/customer/getRoot?check=true&${qs.stringify(params, { indices: false })}`);
}
